// 默认obj为执行元素
// 响应式

function setFont() {
  const html = document.documentElement;
  const designFontSize = 100; // 设计稿基准字体大小
  const breakpoint = 752; // 断点，区分手机端和桌面端
  const maxWindowWidth = 2580; // 最大窗口宽度限制
  const designWidths = {
    desktop: 1920, // 桌面端设计稿宽度
    mobile: 750, // 手机端设计稿宽度
  };
  const calculateFontSize = () => {
    let winWidth = html.getBoundingClientRect().width;
    // 限制窗口宽度不超过 maxWindowWidth
    winWidth = Math.min(winWidth, maxWindowWidth);

    const designWidth =
      winWidth >= breakpoint ? designWidths.desktop : designWidths.mobile;
    let fontSize = (winWidth / designWidth) * designFontSize;

    // 添加最大字体限制（建议值：对于1920设计稿，100px基准时，最大约120-150px）
    const maxFontSize = 100; // 最大字体大小（px）
    fontSize = Math.min(fontSize, maxFontSize);

    html.style.fontSize = `${fontSize}px`;
  };
  calculateFontSize();
  window.addEventListener("resize", calculateFontSize);
  return this;
}
setFont();


// 自定义指令
import Vue from "vue";
//注册'v-animate'  当元素出现在可视范围时添加类名触发动效样式
Vue.directive("animate", {
  inserted: function(el, binding) {
    // 聚焦元素
    binding.addClass = () => {
      const { top } = el.getBoundingClientRect();
      const h =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (top < h) {
        if (el.className.indexOf(binding.value) == -1) {
          // 初次还未绑定过，则新增类名(注意：下面单引号中间是一个空格！！！)
          el.className = binding.value + " " + el.className;
        }
        if (binding.addClass) {
          window.removeEventListener("scroll", binding.addClass);
        }
      }
    };
    window.addEventListener("scroll", binding.addClass, true);
    binding.addClass();
  },
  unbind: function(el, binding) {
    if (binding.addClass) {
      window.removeEventListener("scroll", binding.addClass);
    }
  },
});
